const Globals = {
  //Home
  title: "Aditya Patnaik",
  role: "Software Developer",
  //About
  about_head: "Fullstack Developer",
  about_desc: "I love to",
  hobbies: [
    "work on side-projects implementing latest tech",
    "I read about System Design, Product Development, Design Thinking, Vedic Cosmology and Ancient Scriptures."
  ],
  //Work
  organization: "Infosys",
  position: "Senior Systems Engineer",
  roleAtOrg: "I develop Spring MVC J2EE Applications for clients",
  //Skills
  skills_frontend: [
    "React",
    "Angular X",
    "Electron",
    "Jetpack Compose",
    "Flutter",
    "React Native"
  ],
  skills_backend: [
    "Spring MVC",
    "Spring Boot",
    "Core Java",
    "Node",
    "Express",
    "Django",
    "Flask"
  ],
  skills_database: ["MongoDB", "PostgreSQL"],
  skills_devops: ["Jenkins", "JIRA", "AGILE SPRINTS", "Confluent", "Notion"],
  skill_categories: {
    Frontend: [
      "React",
      "Angular X",
      "Electron",
      "Jetpack Compose",
      "Flutter",
      "React Native"
    ],
    Backend: [
      "Spring MVC",
      "Spring Boot",
      "Core Java",
      "Node",
      "Express",
      "Django",
      "Flask"
    ],
    DevOps: ["Jenkins", "JIRA", "AGILE SPRINTS", "Confluent", "Notion"],
    Database: ["MongoDB", "PostgreSQL"]
  },
  menu: {
    about: "About",
    work: "Work",
    skills: "Skills",
    social: "Social",
    projects: "Projects"
  }
};

export default Globals;
